"use client";

import dynamic from "next/dynamic";

const TextToBark = dynamic(() => import("./TextToBark"));

export default TextToBark;
